import { interviews as e } from "./types/interviews/index.js";
import { contacts as o } from "./types/contacts/index.js";
import { points as n } from "./types/points/index.js";
import { projects as m } from "./types/projects/index.js";
import { groups as s } from "./types/groups/index.js";
var t = /* @__PURE__ */ ((r) => (r[r.NotSpecified = 0] = "NotSpecified", r[r.Mobile = 1] = "Mobile", r[r.Companion = 2] = "Companion", r[r.StudentPortal = 3] = "StudentPortal", r))(t || {});
const S = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ApplicationType: t,
  get contacts() {
    return o;
  },
  get groups() {
    return s;
  },
  get interviews() {
    return e;
  },
  get points() {
    return n;
  },
  get projects() {
    return m;
  }
}, Symbol.toStringTag, { value: "Module" }));
export {
  t as A,
  S as i
};
//# sourceMappingURL=index-D9-bkW7l.js.map
